import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, notification, Button } from "antd";
import Layout from "../layout/Layout";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import dayjs from "dayjs";
import { RollbackOutlined } from "@ant-design/icons";
const { Text } = Typography;

const PouringResumeReport = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [jobList, setJobList] = useState([]);
	const [term, setTerm] = useState("");
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Plant",
			children: [
				{
					title: "ID",
					dataIndex: "deliveryTicket",
					key: "deliveryTicket",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
				{
					title: "Slump",
					dataIndex: "plantSlump",
					key: "plantSlump",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
				{
					title: "Temperature",
					dataIndex: "plantTemperature",
					key: "plantTemperature",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
				{
					title: "Load Time",
					dataIndex: "date",
					key: "date",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
				{
					title: "Departure",
					dataIndex: "departure",
					key: "departure",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
			],
		},
		{
			title: "Job Site",
			children: [
				{
					title: "Slump",
					dataIndex: "jobSiteSlump",
					key: "jobSiteSlump",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
				{
					title: "Temperature",
					dataIndex: "jobSiteTemperature",
					key: "jobSiteTemperature",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
				{
					title: "Drum Rotation",
					dataIndex: "jobSiteDrumRotation",
					key: "jobSiteDrumRotation",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
				{
					title: "Recomended Time to Unload",
					dataIndex: "toJobDate",
					key: "toJobDate",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
				{
					title: "Ambient Temperature",
					dataIndex: "jobSiteAmbientTemperature",
					key: "jobSiteAmbientTemperature",
					render: (value) => {
						return <Text>{value}</Text>;
					},
				},
			],
		},
	];

	useEffect(() => {
		getJobList();
	}, [term, startDate, endDate]);

	const getJobList = async () => {
		try {
			setLoading(true);

			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

			const url =
				api +
				`/load/pouring/57Concrete/list/get?startDate=${start}&endDate=${end}&term=${term}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						deliveryTicket: item.deliveryTicket,
						plantSlump: item.plantSlump || "-",
						plantTemperature: item.plantTemperature
							? `${item.plantTemperature} °F`
							: "-",
						date: item.date
							? dayjs(item.date).format("MM/DD/YYYY hh:mm:ss A")
							: "-",
						departure: item.toJobDate
							? dayjs(item.toJobDate)
									.add(6, "h")
									.format("MM/DD/YYYY hh:mm:ss A")
							: "-",
						jobSiteSlump: item.jobSiteSlump || "-",
						jobSiteTemperature: item.jobSiteTemperature
							? `${item.jobSiteTemperature} °F`
							: "-",
						jobSiteDrumRotation: item.jobSiteDrumRotation || "-",
						toJobDate: item.toJobDate
							? dayjs(item.toJobDate)
									.add(6, "h")
									.add(90, "m")
									.format("MM/DD/YYYY hh:mm:ss A")
							: "-",
						jobSiteAmbientTemperature: item.jobSiteAmbientTemperature
							? `${item.jobSiteAmbientTemperature} °F`
							: "-",
					});
					setJobList(list);
				});
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<CustomTable columns={columns} data={jobList} />
			</Flex>
		);
	};

	const onSearch = (value, _e, info) => {
		if (info?.source === "input") {
			setTerm(value);
		}
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const RenderSearch = () => (
		<CustomSearch
			onSearch={onSearch}
			loading={loading}
			startDate={startDate}
			endDate={endDate}
			onRangeChange={onRangeChange}
			dateFormat={"MM/DD/YYYY"}
		/>
	);

	const goBack = () => {
		history.goBack();
	};

	return (
		<Layout title="Resume Report" description="Report">
			<Flex vertical gap={16}>
				<Button
					type="primary"
					size="large"
					icon={<RollbackOutlined />}
					onClick={goBack}
					loading={loading}
					disabled={loading}
				/>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default PouringResumeReport;
